import React from "react";

const jointLetters = [
  { letter: "ا", forms: { start: "ا", middle: "ا", end: "ا" }, pronunciation: "Alif" },
  { letter: "ب", forms: { start: "بـ", middle: "ـبـ", end: "ـب" }, pronunciation: "Ba" },
  { letter: "ت", forms: { start: "تـ", middle: "ـتـ", end: "ـت" }, pronunciation: "Ta" },
  { letter: "ث", forms: { start: "ثـ", middle: "ـثـ", end: "ـث" }, pronunciation: "Tha" },
  { letter: "ج", forms: { start: "جـ", middle: "ـجـ", end: "ـج" }, pronunciation: "Jeem" },
  { letter: "ح", forms: { start: "حـ", middle: "ـحـ", end: "ـح" }, pronunciation: "Ha" },
  { letter: "خ", forms: { start: "خـ", middle: "ـخـ", end: "ـخ" }, pronunciation: "Kha" },
  { letter: "د", forms: { start: "د", middle: "د", end: "د" }, pronunciation: "Dal" },
  { letter: "ذ", forms: { start: "ذ", middle: "ذ", end: "ذ" }, pronunciation: "Dhal" },
  { letter: "ر", forms: { start: "ر", middle: "ر", end: "ر" }, pronunciation: "Ra" },
  { letter: "ز", forms: { start: "ز", middle: "ز", end: "ز" }, pronunciation: "Zay" },
  { letter: "س", forms: { start: "سـ", middle: "ـسـ", end: "ـس" }, pronunciation: "Seen" },
  { letter: "ش", forms: { start: "شـ", middle: "ـشـ", end: "ـش" }, pronunciation: "Sheen" },
  { letter: "ص", forms: { start: "صـ", middle: "ـصـ", end: "ـص" }, pronunciation: "Sad" },
  { letter: "ض", forms: { start: "ضـ", middle: "ـضـ", end: "ـض" }, pronunciation: "Dad" },
  { letter: "ط", forms: { start: "طـ", middle: "ـطـ", end: "ـط" }, pronunciation: "Taa" },
  { letter: "ظ", forms: { start: "ظـ", middle: "ـظـ", end: "ـظ" }, pronunciation: "Zaa" },
  { letter: "ع", forms: { start: "عـ", middle: "ـعـ", end: "ـع" }, pronunciation: "Ain" },
  { letter: "غ", forms: { start: "غـ", middle: "ـغـ", end: "ـغ" }, pronunciation: "Ghain" },
  { letter: "ف", forms: { start: "فـ", middle: "ـفـ", end: "ـف" }, pronunciation: "Fa" },
  { letter: "ق", forms: { start: "قـ", middle: "ـقـ", end: "ـق" }, pronunciation: "Qaf" },
  { letter: "ك", forms: { start: "كـ", middle: "ـكـ", end: "ـك" }, pronunciation: "Kaf" },
  { letter: "ل", forms: { start: "لـ", middle: "ـلـ", end: "ـل" }, pronunciation: "Lam" },
  { letter: "م", forms: { start: "مـ", middle: "ـمـ", end: "ـم" }, pronunciation: "Meem" },
  { letter: "ن", forms: { start: "نـ", middle: "ـنـ", end: "ـن" }, pronunciation: "Noon" },
  { letter: "هـ", forms: { start: "هـ", middle: "ـهـ", end: "ـه" }, pronunciation: "Ha" },
  { letter: "و", forms: { start: "و", middle: "و", end: "و" }, pronunciation: "Waw" },
  { letter: "ي", forms: { start: "يـ", middle: "ـيـ", end: "ـي" }, pronunciation: "Ya" },
];

function speak(text) {
  window.responsiveVoice.speak(text, "Arabic Male");
}

function JointLetters() {
  return (
    <div dir="rtl" className="p-4 sm:p-6 text-center font-arabic min-h-screen bg-gradient-to-br from-pink-100 to-yellow-50">
      <h2 className="text-4xl sm:text-5xl font-bold mb-6 text-purple-900">الحروف الموصولة</h2>

      <div className="overflow-x-auto">
        <table className="table-auto border w-full max-w-4xl mx-auto text-center shadow-lg rounded-lg bg-white p-4">
          <thead className="bg-purple-300 text-purple-900">
            <tr>
              <th className="p-3 text-lg">الحرف</th>
              <th className="p-3 text-lg">أول الكلمة</th>
              <th className="p-3 text-lg">وسط الكلمة</th>
              <th className="p-3 text-lg">آخر الكلمة</th>
            </tr>
          </thead>
          <tbody>
            {jointLetters.map(({ letter, forms, pronunciation }, idx) => (
              <tr key={idx} className="hover:bg-purple-200 transition-all duration-300">
                <td className="p-4 text-3xl font-bold text-purple-700">
                  <button
                    onClick={() => speak(letter)}
                    title={pronunciation}
                    className="px-4 py-2 rounded-lg bg-purple-400 text-white font-semibold hover:bg-purple-500 transition-all duration-200"
                  >
                    {letter}
                  </button>
                </td>
                <td className="p-4 text-xl">
                  <button
                    onClick={() => speak(forms.start)}
                    className="px-4 py-2 rounded-lg bg-yellow-300 text-purple-700 font-semibold hover:bg-yellow-400 transition-all duration-200"
                  >
                    {forms.start}
                  </button>
                </td>
                <td className="p-4 text-xl">
                  <button
                    onClick={() => speak(forms.middle)}
                    className="px-4 py-2 rounded-lg bg-pink-300 text-purple-700 font-semibold hover:bg-pink-400 transition-all duration-200"
                  >
                    {forms.middle}
                  </button>
                </td>
                <td className="p-4 text-xl">
                  <button
                    onClick={() => speak(forms.end)}
                    className="px-4 py-2 rounded-lg bg-green-300 text-purple-700 font-semibold hover:bg-green-400 transition-all duration-200"
                  >
                    {forms.end}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <script src="https://code.responsivevoice.org/responsivevoice.js?key=1X64heoV"></script>
    </div>
  );
}

export default JointLetters;
